import { useRef, useState } from 'react';
import ReUploadIcon from '../../../assets/svg/re-upload.svg?react';
import FJLocalStore from '../../../store/FJLocalStore';
import {
    UPLOAD_FILE_TYPE,
    CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES,
} from '../../../config/dataConfig/FJGenerateData';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FJPreviewBox from '../../../common/components/FJPreviewBox/FJPreviewBox';
import FJDeleteIcon from '../../../assets/svg/close.svg?react';

import styles from './FJClothesChangerImageUpload.module.less';

const FJClothesChangerImageUpload = props => {
    const {
        imageInfo = {},
        uploadImg,
        defaultIcon,
        uploadText,
        smallLabel,
        smallIcon,
        className,
        openMediaLibrary,
        onClearImage,
        previewClassName,
    } = props;
    const { src: imgSrc } = imageInfo;
    const inputRef = useRef(null);
    const [isDraggingFile, setIsDraggingFile] = useState(false);
    const _onUploadImg = e => {
        const file = e.target.files[0];
        uploadImg(file);
        e.target.value = null;
    };

    const _onClick = () => {
        if (window.isEditPage && openMediaLibrary) {
            openMediaLibrary();
        } else if (inputRef.current) {
            inputRef.current.click();
        }
    };
    const _onDragOver = e => {
        e.stopPropagation();
        e.preventDefault();
        setIsDraggingFile(true);
    };

    const _onDragLeave = e => {
        e.stopPropagation();
        e.preventDefault();
        setIsDraggingFile(false);
    };

    const _onDragDrop = e => {
        e.stopPropagation();
        e.preventDefault();
        setIsDraggingFile(false);
        let files = e.dataTransfer.files;
        if (files && files.length > 0) {
            const file = files[0];
            uploadImg(file);
        }
    };

    const _onDelete = e => {
        e.stopPropagation();
        e.preventDefault();
        onClearImage();
    };

    return (
        <div
            className={classNames(
                className,
                styles.box,
                imgSrc ? styles.has_img : '',
                isDraggingFile ? styles.dragging : '',
            )}
            onClick={_onClick}
            onDragOver={_onDragOver}
            onDrop={_onDragDrop}
            onDragLeave={_onDragLeave}
        >
            {imgSrc ? (
                <>
                    <div className={styles.upload_border_box}></div>
                    <img
                        className={classNames(styles.preview_img, previewClassName)}
                        src={imgSrc}
                        alt=''
                        loading='lazy'
                    />
                    <span className={styles.small_label}>{FJLocalStore._(smallLabel)}</span>
                    <div className={classNames(styles.blur_mask, isDraggingFile ? styles.dragging : '')}>
                        <ReUploadIcon />
                        <span className={styles.reupload_text}>{FJLocalStore._('replace')}</span>
                    </div>
                    <div className={styles.small_icon}>{smallIcon?.()}</div>
                    <div className={styles.delete_icon} onClick={_onDelete}>
                        <FJDeleteIcon />
                    </div>
                </>
            ) : (
                <div className={styles.blank_box}>
                    <div className={styles.upload_border_box}></div>
                    {defaultIcon?.()}
                    <span className={classNames(styles.blank_text)}>{FJLocalStore._(uploadText)}</span>
                </div>
            )}
            <input
                type='file'
                ref={inputRef}
                className={styles.file_input}
                accept={UPLOAD_FILE_TYPE + CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES}
                onChange={_onUploadImg}
            />

            <div className={styles.dragging_mask}></div>
            <FJPreviewBox imageInfo={imageInfo} />
        </div>
    );
};
FJClothesChangerImageUpload.propTypes = {
    imageInfo: PropTypes.object,
    uploadImg: PropTypes.func,
    defaultIcon: PropTypes.func,
    uploadText: PropTypes.string,
    smallLabel: PropTypes.string,
    smallIcon: PropTypes.func,
    className: PropTypes.string,
    openMediaLibrary: PropTypes.func,
    onClearImage: PropTypes.func,
    previewClassName: PropTypes.string,
};

export default FJClothesChangerImageUpload;
